import React, { CSSProperties, FC, Fragment, useEffect } from 'react';
import { useSettings } from '../../../hooks/useSettings';

function camelToSpaceCase(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

function styleObjectToString(style: CSSProperties): string {
  return Object.entries(style)
    .map(([key, value]) => {
      const normalizedKey = camelToSpaceCase(key);

      if (typeof value === 'object') {
        return `${normalizedKey}{${styleObjectToString(value)};}`;
      }

      if (normalizedKey === 'font-family') {
        return `${normalizedKey}:'${value}'`;
      }

      return `${normalizedKey}:${value}`;
    })
    .join(';');
}

function createStyleElement(styleString: string) {
  const styleElement = document.createElement('style');
  styleElement.innerHTML = styleString;
  document.head.appendChild(styleElement);
}

const GlobalStyleTag: FC = () => {
  const { globalScopeCSS } = useSettings();

  useEffect(() => {
    if (!globalScopeCSS) return;

    const globalStyles = globalScopeCSS.map((styleObject) => {
      return styleObjectToString(styleObject as CSSProperties);
    });

    createStyleElement(globalStyles.join(''));
  }, [globalScopeCSS]);

  return <Fragment />;
};

export default GlobalStyleTag;
